import { http, uploadFile } from '@/utils/axios'

/**
 * @msg: 获取所有专业
 */
export function getAllCategory() {
  return http({
    url: http.baseUrl('course/getAllCategory'),
    method: 'get'
  })
}

/**
 * @msg: 获取学校
 */
export function getNormalList() {
  return http({
    url: http.baseUrl('elSchool/getNormalList'),
    method: 'post'
  })
}

/**
 * @msg: 获取课程所属专业
 */
export function getMajorNameList() {
  return http({
    url: http.baseUrl('courseWare/getAllMajor'),
    method: 'get'
  })
}

/**
 * @msg: 获取课程审核列表
 */
export function getCourseReviewList({
  page = 0,
  pageSize = 10,
  status = '',
  courseName,
  payStatus,
  zName,
  minCtime,
  maxCtime,
  majorName,
  verifyStatus,
  phone,
  uName,
  verifyMode,
  checkName,
  admissionCard,
  orderId,
  schoolId,
  minPrice,
  maxPrice,
  uid = '',
  userType = '',
  mhmId = '',
  batch,
  applyBatch
      

}) {
  return http({
    url: http.baseUrl('userApprove/elZyVideoApprove'),
    method: 'get',
    params: http.params({
      page,
      pageSize,
      status,
      courseName,
      payStatus,
      zName,
      minCtime: minCtime ? minCtime / 1000 : minCtime,
      maxCtime: maxCtime ? maxCtime / 1000 : maxCtime,
      majorName,
      verifyStatus,
      phone,
      uName,
      verifyMode,
      checkName,
      admissionCard,
      orderId,
      schoolId,
      minPrice,
      maxPrice,
      uid,
      userType,
      mhmId,
      batch,
      applyBatch
    })
  })
}

/**
 * @msg: 获取课程审核列表分页
 */
export function getCourseReviewListCount({
  page = 0,
  pageSize = 10,
  status = '',
  courseName,
  payStatus,
  zName,
  minCtime,
  maxCtime,
  majorName,
  verifyStatus,
  phone,
  uName,
  verifyMode,
  checkName,
  admissionCard,
  orderId,
  schoolId,
  minPrice,
  maxPrice,
  uid = '',
  userType = '',
  mhmId = '',
  batch,
  applyBatch
}) {
  return http({
    url: http.baseUrl('userApprove/elZyVideoApproveCount'),
    method: 'get',
    params: http.params({
      page,
      pageSize,
      status,
      courseName,
      payStatus,
      zName,
      minCtime: minCtime ? minCtime / 1000 : minCtime,
      maxCtime: maxCtime ? maxCtime / 1000 : maxCtime,
      majorName,
      verifyStatus,
      phone,
      uName,
      verifyMode,
      checkName,
      admissionCard,
      orderId,
      schoolId,
      minPrice,
      maxPrice,
      uid,
      userType,
      mhmId,
      batch,
      applyBatch
    })
  })
}

/**
 * @msg: 统计筛选结果
 */
export function exportStatisticsExcel({
  status = '',
  courseName,
  payStatus,
  zName,
  minCtime,
  maxCtime,
  majorName,
  verifyStatus,
  phone,
  uName,
  verifyMode,
  checkName,
  admissionCard,
  orderId,
  schoolId,
  minPrice,
  maxPrice,
  uid = '',
  userType = '',
  mhmId = '' }) {
  return http({
    url: http.baseUrl('userApprove/exportStatisticsExcel'),
    method: 'get',
    responseType: 'blob',
    params: http.params({
      status,
      courseName,
      payStatus,
      zName,
      minCtime: minCtime ? minCtime / 1000 : minCtime,
      maxCtime: maxCtime ? maxCtime / 1000 : maxCtime,
      majorName,
      verifyStatus,
      phone,
      uName,
      verifyMode,
      checkName,
      admissionCard,
      orderId,
      schoolId,
      minPrice,
      maxPrice,
      uid,
      userType,
      mhmId
    })
  })
}

/**
 * @msg: 导出筛选结果
 */
export function outExcel({
  status = '',
  courseName,
  payStatus,
  zName,
  minCtime,
  maxCtime,
  majorName,
  verifyStatus,
  phone,
  uName,
  verifyMode,
  checkName,
  admissionCard,
  orderId,
  schoolId,
  minPrice,
  maxPrice,
  uid = '',
  userType = '',
  mhmId = '' }) {
  return http({
    url: http.baseUrl('userApprove/exportExcel'),
    method: 'get',
    responseType: 'blob',
    params: http.params({
      status,
      courseName,
      payStatus,
      zName,
      minCtime: minCtime ? minCtime / 1000 : minCtime,
      maxCtime: maxCtime ? maxCtime / 1000 : maxCtime,
      majorName,
      verifyStatus,
      phone,
      uName,
      verifyMode,
      checkName,
      admissionCard,
      orderId,
      schoolId,
      minPrice,
      maxPrice,
      uid,
      userType,
      mhmId
    })
  })
}

/**
 * @msg: 查看报名信息
 */
export function getUserInfo(uid = '', courseId = '', type = '') {
  return http({
    url: http.baseUrl('applyUser/getUserInfo'),
    method: 'get',
    params: http.params({
      uid,
      courseId,
      type
    })
  })
}

/**
 * @msg: 新增/修改报名用户信息
 */
export function saveOrUpdateUserInfo(data) {
  return http({
    url: http.baseUrl('applyUser/saveOrUpdate'),
    method: 'post',
    data
  })
}

/**
 * @msg: 新增/修改报名用户信息(新接口)
 */
export function updateUserInfo(data) {
  return http({
    url: http.baseUrl('applyUser/update'),
    method: 'post',
    data
  })
}

/**
 * @msg: 更新数据状态
 */
export function updateApproveStatus({ ids = '', noPassReason = '', infoType = '', verifyStatus = '', uid = '', sIds = '', uName = '' }) {
  return http({
    url: http.baseUrl('userApprove/updateApproveStatus'),
    method: 'post',
    params: http.params({
      ids,
      infoType,
      verifyStatus,
      uid,
      sIds,
      uName,
      noPassReason
    }),
  })
}

/**
 * @msg: 审核不通过时退款
 */
export function doRefund(data) {
  return http({
    url: http.baseUrl('elZyOrderRefund/doRefund'),
    method: 'post',
    params: http.params(data)
  })
}

/**
 * @msg: 提交用户简表
 */
export function upload(file, idCard = '',batchId='') {
  const formData = new FormData()
  formData.append('file', file)
  formData.append('idCard', idCard)
  formData.append('batchId', batchId)
  return uploadFile(http.baseUrl('file/upload'), formData)
}

/**
 * @msg: 获取用户简表(文件流)
 */
export function getUserFileInfo(idCard = '',batchId) {
  return http({
    url: http.baseUrl('file/getUserInfo'),
    method: 'get',
    params: http.params({
      idCard: idCard,
      batchId: batchId
    }),
    responseType: 'blob'
  })
}

/**
 * @msg: 获取用户简表文件类型
 */
export function getFileType(idCard = '',batchId) {
  return http({
    url: http.baseUrl('file/getFileType'),
    method: 'get',
    params: http.params({
      idCard: idCard,
      batchId: batchId
    })
  })
}
